import VueCookies from "vue-cookies"
import $store from '../store'
import $router from "../router";

export function _getAccessToken() {
    return VueCookies.get('accessToken') || false
}

export function _getRefreshToken() {
    return VueCookies.get('refreshToken') || false
}

export async function _checkRefreshingToken() {
    return $store.state.main.isTokenRefreshing
}

export function _checkUserExpiration() {
    const expirationTime = parseInt(VueCookies.get('expireIn'))
    let now = new Date().getTime() / 1000
    now = ~~now
    return expirationTime - now
}

export async function _setAuthData({ accessToken, refreshToken, expireIn }, setInStorage = false) {

    // console.log('setting Auth data')

    if (setInStorage) {
        const time = parseInt(Math.floor(new Date().getTime() / 1000))
        const expireInTime = time + parseInt(expireIn)

        await VueCookies.set('accessToken', accessToken, '168D')
        await VueCookies.set('expireIn', expireInTime, '168D')

        await VueCookies.set('refreshToken', refreshToken, '168D')

    }
    await $store.commit('main/SET', { key: 'accessToken', value: accessToken })
    await $store.commit('main/SET', { key: 'refreshToken', value: refreshToken })
    const parseAccessToken = await _parseAccessToken(accessToken)
    await $store.commit('main/SET', { key: 'parsedToken', value: parseAccessToken })
    await $store.commit('main/APPEND', { key: 'user', value: { roles: parseAccessToken.roles } })
    await $store.commit('main/APPEND', { key: 'user', value: { id: parseAccessToken.id } })
}

export async function _resetAuthData(showMessage = true) {

    VueCookies.remove('refreshToken')
    VueCookies.remove('accessToken')
    VueCookies.remove('expireIn')
    $store.commit('main/DELETE', { key: 'accessToken' })
    $store.commit('main/DELETE', { key: 'refreshToken' })
    $store.commit('main/DELETE', { key: 'expireIn' })
    $store.commit('main/DELETE', { key: 'user', type: 'object' })

    if (showMessage)
        await $store.dispatch('main/alerts', {
            type: 'error',
            title: 'شما از سایت خارج شده اید!',
            message: 'لطفا دوباره وارد شوید.'
        })

}

export async function _parseAccessToken(token) {
    if (token.indexOf(' ') !== -1) {
        token = token.split(' ')[1]
    }
    if (token.split('.').length <= 0)
        await _resetAuthData()
    try {
        const result = JSON.parse(require('base-64').decode(token.split('.')[1].replace('-', '+').replace('_', '/')))
        return result
    } catch (e) {
        // console.log(e)
        // await _resetAuthData()
    }
}

/**
 * Return message for HTTP status code
 * @param {number} status - HTTP status code
 * @returns {string} Message of network operation
 */
function _getStatusMessage(status) {
    let message = ''
    switch (status) {
        case 200:
            message = 'All done. Request successfully executed'
            break
        case 201:
            message = 'Data successfully created'
            break
        case 400:
            message = 'Bad Request'
            break
        case 401:
            message = 'Need auth'
            break
        case 404:
            message = 'Not found'
            break
        case 503:
            message = 'Service Unavailable'
            break
        default:
            message = 'Something wrong. Client default error message'
            break
    }
    return message
}

function _getResponseErrorMessage(error) {
    if (error.response && error.response.data) return error.response.data.message
    if (error.response && error.response.message) return error.response.message
    if (error.message) return error.message
    return '_getResponseErrorMessage can\'t handle error'
}

export async function _handleError(error, action = 'get', showError) {
    if (Object.keys(error).length <= 0)
        return false

    if (error.status === 401 || error.status === 403) {
        await _resetAuthData(false)
        await $router.push({ path: '/auth' })
    }

    if (showError) {
        // if (action === 'get')
        //   await $router.push({name: 'error_page', params: {error: error}})
        // else {
        $store.dispatch('main/alerts', { type: 'error', title: 'خطا', message: error.message })
            // }
    }

    return null
}

/**
 * Create instant, which represent response object
 * @param {Object} [data] - custom data
 * @param {Object} [response] - axios response object
 * @param {String} [message] - custom message to display
 */
export class ResponseWrapper {
    constructor(response, data = {}, message) {
        this.data = data
        this.success = response.data.status
        this.status = response.status
        this.statusMessage = _getStatusMessage(this.status)
        this.message = response.data.response || null
    }
}

/**
 * Create instant, which represent error object
 * @param {Object} [error] - axios error object
 * @param {String} [message] - custom message to display
 */
export class ErrorWrapper {
    constructor(error, message) {
        // super()
        // this.name = 'ErrorWrapper'
        // this.stack = new Error().stack
        // console.log(error.response)
        this.success = error.response ? error.response.data.status : false
        this.status = error.response ? error.response.status : false
            // this.statusMessage = _getStatusMessage(this.status)
        this.statusMessage = error.response.statusText
        this.message = message || _getResponseErrorMessage(error)
    }
}